import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

// @mui
import { Stack, Button, Container, Typography } from "@mui/material";
// ----------------------------------------------------------------------

export default function HeadshotsFoldersPage() {
  const navigate = useNavigate();

  const handleSelect = (folder) => () =>
    navigate(`/dashboard/headshots/${folder}`);

  return (
    <>
      <Helmet>
        <title> Headshots Folder </title>
      </Helmet>

      <Container>
        <Typography variant="h4" gutterBottom>
          Headshots folders
        </Typography>
        <Stack direction="row" alignItems="center" mb={5} gap={1}>
          <Button
            variant="outlined"
            component="label"
            sx={{ height: "120px", width: "120px" }}
            onClick={handleSelect("players")}
          >
            Players
          </Button>
          <Button
            variant="outlined"
            component="label"
            sx={{ height: "120px", width: "120px" }}
            onClick={handleSelect("teams")}
          >
            Teams
          </Button>
        </Stack>
      </Container>
    </>
  );
}
